import React ,{useEffect} from 'react';
import AOS from 'aos';
import Banner from '../Components/Pages/Author/Banner';
import Load from '../Components/Pages/Author/Load';
import Header from '../Components/Shared/Header/Header';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function Author(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header styles="scrolled"/>
        <Banner />
        <Load />
        <Start />
        <Footer />
        </>
    )
};
export default Author ;